import React from 'react'
import PropTypes from 'prop-types'
import tokens from 'app/Theme/tokens'
import { ConfigProvider, Menu } from 'antd'

const menu_classes = [
  'mobile-navigation-menu !m-0 !p-0',
  '[&_.ant-menu-item]:!flex [&_.ant-menu-item]:!items-center',
  '[&_.ant-menu-item]:!leading-[22px] [&_.ant-menu-title-content]:!whitespace-normal',
  '[&_.ant-menu-title-content]:!font-base [&_.ant-menu-title-content]:!text-[16px]',
  '[&_.ant-menu-item-selected]:!rounded-[10px]',
  '[&_.ant-menu-item-selected]:shadow-[inset_3px_0_0_#0093EE]',
  '[&_.ant-menu-title-content]:font-semibold',
  '[&_.ant-menu-item-icon]:!text-[22px] [&_.ant-menu-item-icon]:!text-inherit',
].join(' ')
const divided_item_classes = [
  '[&_.ant-menu-item:not(.ant-menu-item-selected)]:!rounded-none',
  '[&_.ant-menu-item-selected]:!border-transparent',
  '[&_.ant-menu-item:not(:last-child)]:border-0',
  '[&_.ant-menu-item:not(:last-child)]:border-b',
  '[&_.ant-menu-item:not(:last-child)]:border-solid',
  '[&_.ant-menu-item:not(:last-child)]:border-border-line',
].join(' ')

// Sections and account actions share the same existing Ant Design menu contract.
const MobileNavigationMenu = ({ divided = false, className = '', ...props }) => (
  <ConfigProvider
    theme={{
      components: {
        Menu: {
          itemHeight: 52,
          itemMarginInline: 0,
          itemMarginBlock: 2,
          itemPaddingInline: 12,
          iconSize: 22,
          fontSize: 16,
          itemBorderRadius: 10,
          itemColor: tokens.colorDarkText,
          itemHoverColor: tokens.colorPrimary,
          itemHoverBg: tokens.colorHoverBlue,
          itemSelectedColor: tokens.colorPrimary,
          itemSelectedBg: tokens.colorHoverBlue,
        },
      },
    }}
  >
    <Menu
      mode="inline"
      style={{ border: 0 }}
      {...props}
      className={[menu_classes, divided && divided_item_classes, className].filter(Boolean).join(' ')}
    />
  </ConfigProvider>
)
MobileNavigationMenu.propTypes = { divided: PropTypes.bool, className: PropTypes.string }
export default MobileNavigationMenu
